import { css } from '@emotion/css';
import userApi from 'apis/userApi';
import LoadingIcon from 'components/loading/LoadingIcon';
import Modal from 'components/modal/Modal';
import { colors } from 'constants/theme';
import { BankCardAddPayload, UsdtWalletAddPayload } from 'models/bankModel';
import { isAddress } from 'ethers';
import { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { FaCheck } from 'react-icons/fa6';
import { IoMdClose } from 'react-icons/io';
import styles from './add-bank.style';
const locateBank = {
    nprovince: 'Việt Nam',
    ncity: 'Việt Nam',
};

interface Props {
    onSubmit: (bankPayload: BankCardAddPayload) => void;
    onSubmitUsdt?: (payload: UsdtWalletAddPayload) => void;
    onClose: () => void;
    bankList: string[];
}
export default function AddBankPerson(props: Props) {
    const { onSubmit, onSubmitUsdt, onClose, bankList } = props;
    const [channelType, setChannelType] = useState<'bank' | 'usdt'>('bank');
    const [step, setStep] = useState<1 | 2>(1);
    const [bankName, setBankName] = useState<string>('');
    const [usdtPayload, setUsdtPayload] = useState<UsdtWalletAddPayload>({ nname: '', wallet: '', network: 'BSC-BEP20', checkpwd: '' });
    const [loading, setLoading] = useState(false);
    const [bankConfirmData, setBankConfirmData] = useState<BankCardAddPayload>({} as BankCardAddPayload);
    const [showBankList, setShowBankList] = useState(false);

    const {
        register,
        handleSubmit,
        setError,
        clearErrors,
        formState: { errors },
    } = useForm<BankCardAddPayload>();

    const submitAddBankCheck: SubmitHandler<BankCardAddPayload> = async (values) => {
        const { nbankcard, bankcard2, nname } = values;
        if (!bankName) {
            toast.error('Vui lòng chọn ngân hàng');
            return;
        }

        if (nbankcard !== bankcard2) {
            setError('bankcard2', { message: 'Nhập lại số tài khoản không đúng' });
            return;
        }

        setLoading(true);
        const payload = {
            ...values,
            nname: nname.trim().toLocaleLowerCase(),
            ...locateBank,
            nbankname: bankName,
        };
        if (payload.nbranchotherbank) delete payload.nbranchotherbank;

        try {
            const { data } = await userApi.addBankcardCheck(payload);
            if (!data.msg) {
                setStep(2);
                setBankConfirmData(payload);
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const changeAlias = (alias: string, removeNumber: boolean, typeInput: any) => {
        let str = alias;
        str = str.toUpperCase();
        if (removeNumber) {
            str = str.replace(/[0-9]/g, '');
        } else {
            str = str.replace(/ /g, '');
        }
        str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ắ|Ằ|Ặ|Ẳ|Ẵ/g, 'A');
        str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
        str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
        str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
        str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
        str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
        str = str.replace(/Đ/g, 'D');
        str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, '');
        str = str.replace(/ + /g, '');
        if (alias !== '') {
            clearErrors(typeInput);
        }
        return str;
    };

    const handleSubmitAddBank = async () => {
        onSubmit(bankConfirmData);
    };

    const handleSelectBank = (bank: string) => {
        setBankName(bank);
        setShowBankList(false);
    };

    const submitUsdt = () => {
        if (!onSubmitUsdt) return;
        if (!usdtPayload.nname.trim()) return toast.error('Vui lòng nhập tên ví');
        if (!usdtPayload.wallet.trim()) return toast.error('Vui lòng nhập địa chỉ ví');
        if (!isAddress(usdtPayload.wallet.trim())) return toast.error('Địa chỉ ví không hợp lệ!');
        if (!usdtPayload.checkpwd) return toast.error('Vui lòng nhập mật khẩu thanh toán');
        onSubmitUsdt({ ...usdtPayload, nname: usdtPayload.nname.trim(), wallet: usdtPayload.wallet.trim() });
    };

    return (
        <>
            <div className={styles.wrap}>
                <div className={styles.heading}>
                    <h6> {step === 2 ? 'Xác minh tài khoản' : 'Thêm Ngân Hàng'}</h6>
                    <button type="button" onClick={onClose}>
                        <IoMdClose size={20} color="black" />
                    </button>
                </div>
                {step === 1 && channelType === 'bank' && (
                    <form className={styles.formAddBank} onSubmit={handleSubmit(submitAddBankCheck)}>
                        <div className={styles.channelTypeSelector}>
                            <label>Loại kênh:</label>
                            <div className="channel-radio-group">
                                <input type="radio" id="add-bank-channel-bank" name="add-bank-channel" checked readOnly />
                                <label htmlFor="add-bank-channel-bank"> Ngân hàng</label>
                                <input type="radio" id="add-bank-channel-network" name="add-bank-channel" checked={false} onChange={() => setChannelType('usdt')} />
                                <label htmlFor="add-bank-channel-network"> Mạng lưới</label>
                            </div>
                        </div>
                        <div className={`${styles.groupInput} form-group-common`}>
                            <div className="titleValue">
                                <p>Tên ngân hàng:</p>
                            </div>

                            <select className={styles.bankName} value={bankName} onChange={(e) => setBankName(e.target.value)}>
                                {bankList.map((bank, index) => (
                                    <option value={bank} key={index}>
                                        {bank}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className={styles.groupInput}>
                            <div className="titleValue">
                                <p>Chi nhánh:</p>
                            </div>
                            <div className={styles.wrapInput}>
                                <input
                                    {...register('nbranchname', {
                                        required: true,
                                        maxLength: {
                                            value: 30,
                                            message: 'Tối thiểu 30 ký tự',
                                        },
                                    })}
                                    type="text"
                                />
                            </div>
                            <span className={styles.hintText}>Từ 2 đến 30 kí tự</span>
                            <div className={styles.errorInput}>{errors['nbranchname'] && <small>{errors['nbranchname']?.message || 'Vui lòng nhập trường này!'}</small>}</div>
                        </div>

                        <div className={styles.groupInput}>
                            <div className="titleValue">
                                <p>Tên Chủ Tài Khoản:</p>
                            </div>

                            <div className={styles.wrapInput}>
                                <input
                                    {...register('nname', {
                                        required: true,
                                    })}
                                    type="text"
                                    onChange={(e: any) => (e.target.value = changeAlias(e.target.value, true, 'nname'))}
                                />
                                <p>Tên tài khoản nên là chữ IN HOA và không dấu</p>
                            </div>

                            <span className={styles.hintText}>Từ 2 đến 30 kí tự</span>
                            <div className={styles.errorInput}>{errors['nname'] && <small>{errors['nname'].message || 'Vui lòng nhập trường này!'}</small>}</div>
                        </div>

                        <div className={styles.groupInput}>
                            <div className="titleValue">
                                <p>Số Tài Khoản:</p>
                            </div>
                            <div className={styles.wrapInput}>
                                <input
                                    {...register('nbankcard', {
                                        required: true,
                                    })}
                                    type="text"
                                    onChange={(e: any) => (e.target.value = changeAlias(e.target.value, false, 'nbankcard'))}
                                />
                                <p>Điền đúng số tài khoản, không phải số thẻ ATM</p>
                            </div>
                            <span className={styles.hintText}>Từ 5 đến 15 kí tự</span>
                            <div className={styles.errorInput}>{errors['nbankcard'] && <small>{errors['nbankcard'].message || 'Vui lòng nhập trường này!'}</small>}</div>
                        </div>

                        <div className={styles.groupInput}>
                            <div className="titleValue">
                                <p>Nhập Lại Số Tài Khoản:</p>
                            </div>
                            <div className={styles.wrapInput}>
                                <input
                                    {...register('bankcard2', {
                                        required: true,
                                    })}
                                    type="text"
                                    onChange={(e: any) => (e.target.value = changeAlias(e.target.value, false, 'bankcard2'))}
                                />
                            </div>
                            <span className={styles.hintText}>Xác nhận lại tài khoản ngân hàng</span>
                            <div className={styles.errorInput}>{errors['bankcard2'] && <small>{errors['bankcard2'].message || 'Vui lòng nhập trường này!'}</small>}</div>
                        </div>

                        <div className={styles.groupInput}>
                            <div className="titleValue">
                                <p>Mật Khẩu Thanh Toán:</p>
                            </div>
                            <div className={styles.wrapInput}>
                                <input
                                    {...register('checkpwd', {
                                        required: true,
                                    })}
                                    type="password"
                                />
                            </div>
                            <span className={styles.hintText}>Vui lòng nhập mật khẩu quỹ tiền</span>
                            <div className={styles.errorInput}>{errors['checkpwd'] && <small>{errors['checkpwd'].message || 'Vui lòng nhập trường này!'}</small>}</div>
                        </div>

                        <button type="submit" className={styles.btnSubmit} style={{ marginTop: '12px' }}>
                            Bước Tiếp Theo
                        </button>
                    </form>
                )}
                {step === 1 && channelType === 'usdt' && (
                    <div className={styles.formAddBank}>
                        <div className={styles.channelTypeSelector}>
                            <label>Loại kênh:</label>
                            <div className="channel-radio-group">
                                <input type="radio" id="add-usdt-channel-bank" name="add-usdt-channel" checked={false} onChange={() => setChannelType('bank')} />
                                <label htmlFor="add-usdt-channel-bank"> Ngân hàng</label>
                                <input type="radio" id="add-usdt-channel-network" name="add-usdt-channel" checked readOnly />
                                <label htmlFor="add-usdt-channel-network"> Mạng lưới</label>
                            </div>
                        </div>

                        <div className={styles.groupInput}>
                            <div className="titleValue">
                                <p>Tên chủ tài khoản ngân hàng:</p>
                            </div>
                            <div className={styles.wrapInput}>
                                <input type="text" maxLength={30} value={usdtPayload.nname} onChange={(e) => setUsdtPayload({ ...usdtPayload, nname: e.target.value.toUpperCase() })} />
                                <p>Tên tài khoản nên là chữ IN HOA và không dấu</p>
                            </div>
                            <span className={styles.hintText}>Từ 2 đến 30 kí tự</span>
                        </div>

                        <div className={styles.groupInput}>
                            <div className="titleValue">
                                <p>Địa chỉ ví:</p>
                            </div>
                            <div className={styles.wrapInput}>
                                <input type="text" maxLength={100} value={usdtPayload.wallet} onChange={(e) => setUsdtPayload({ ...usdtPayload, wallet: e.target.value })} />
                            </div>
                            <span className={styles.hintText}>Vui lòng nhập địa chỉ ví</span>
                        </div>

                        <div className={styles.groupInput}>
                            <div className="titleValue">
                                <p>Mạng lưới:</p>
                            </div>
                            <select className={styles.bankName} value={usdtPayload.network} onChange={(e) => setUsdtPayload({ ...usdtPayload, network: e.target.value })}>
                                <option value="BSC-BEP20">BSC-BEP20</option>
                            </select>
                        </div>

                        <div className={styles.groupInput}>
                            <div className="titleValue">
                                <p>Mật khẩu thanh toán:</p>
                            </div>
                            <div className={styles.wrapInput}>
                                <input type="password" maxLength={30} value={usdtPayload.checkpwd} onChange={(e) => setUsdtPayload({ ...usdtPayload, checkpwd: e.target.value })} />
                            </div>
                            <span className={styles.hintText}>Vui lòng nhập mật khẩu quỹ tiền</span>
                        </div>

                        <button type="button" className={styles.btnSubmit} style={{ marginTop: '12px' }} onClick={submitUsdt}>
                            Bước Tiếp Theo
                        </button>
                    </div>
                )}
                {step === 2 && (
                    <div className={styles.viewConfirm}>
                        <p className={styles.noteConfirm}>Vui lòng xác nhận thông tin ngân hàng của bạn một lần nữa.</p>
                        <div className={styles.infoBankList}>
                            <div className={styles.infoBankItem}>
                                <p>Tên Ngân Hàng</p>
                                <p>{bankConfirmData.nbankname}</p>
                            </div>
                            <div className={styles.infoBankItem}>
                                <p>Chi Nhánh</p>
                                <p>{bankConfirmData.nbranchname}</p>
                            </div>
                            <div className={styles.infoBankItem}>
                                <p>Tên Tài Khoản</p>
                                <p>{bankConfirmData.nname}</p>
                            </div>
                            <div className={styles.infoBankItem}>
                                <p>Số Tài Khoản</p>
                                <p className="bankCard">{bankConfirmData.nbankcard}</p>
                            </div>
                            <div className={styles.infoBankItem}>
                                <div style={{ width: 300 }} />
                                <button type="button" className="btnBankCard" onClick={handleSubmitAddBank}>
                                    Xác nhận
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* show bank list */}
            <Modal isShow={showBankList} onClose={() => setShowBankList(false)} width="440px" closeClickBackdrop>
                <BankListSuggest bankSelect={bankName} bankData={bankList} onSelectBank={handleSelectBank} onClose={() => setShowBankList(false)} />
            </Modal>
            {loading && <LoadingIcon />}
        </>
    );
}

interface PropsBankList {
    bankData: string[];
    onSelectBank: (bank: string) => void;
    onClose: () => void;
    bankSelect: string;
}
const BankListSuggest = (props: PropsBankList) => {
    const { bankData, onSelectBank, onClose, bankSelect } = props;
    const [bankList, setBankList] = useState(bankData);
    const filterBank = (key: string) => {
        const bankMap = bankData.filter((bank) => bank.toLowerCase().includes(key));
        setBankList(bankMap);
    };
    return (
        <div className={stylesBankList.wrap}>
            <div className={stylesBankList.header}>
                <div className="header-title">
                    <h2>Chọn Ngân hàng</h2>
                    <button type="button" onClick={onClose}>
                        <IoMdClose size={36} color={colors.primary} />
                    </button>
                </div>
                <input type="text" placeholder="Tìm ngân hàng..." onChange={(e) => filterBank(e.target.value)} />
            </div>

            <div className={stylesBankList.bankContent}>
                {bankList.length > 0 ? (
                    bankList.map((bank, index) => (
                        <div className={`bank-item ${bankSelect === bank ? 'active' : ''}`} key={index} onClick={() => onSelectBank(bank)}>
                            <span>{bank}</span>
                            {bankSelect === bank && <FaCheck size={20} color={colors.primary} />}
                        </div>
                    ))
                ) : (
                    <div className={stylesBankList.noBank}>
                        <p>Không tìm thấy ngân hàng phù hợp</p>
                    </div>
                )}
            </div>
        </div>
    );
};

const stylesBankList = {
    wrap: css`
        background: ${colors.white};
        border-radius: 16px;
        padding-bottom: 16px;
    `,
    bankContent: css`
        height: 400px;
        overflow-y: auto;
        padding-left: 16px;
        .bank-item {
            padding: 12px 0;
            padding-right: 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #f1f1f1;
            color: ${colors.blackText};
            &.active {
                span {
                    color: ${colors.primary};
                }
            }
        }
    `,
    header: css`
        text-align: center;
        padding: 16px;
        background: #f1f1f1;
        border-radius: 16px 16px 0 0;
        .header-title {
            button {
                display: flex;
                position: absolute;

                right: 8px;
                cursor: pointer;
                top: 8px;
            }
        }
        h2 {
            font-size: 20px;
            padding-bottom: 16px;
        }
        input {
            width: 100%;
            padding: 8px 12px;
            border: 1px solid ${colors.blackText};
            border-radius: 8px;
        }
    `,
    noBank: css`
        padding: 40px 0;
        text-align: center;
    `,
};
